<div class="container-delete">
    <mat-icon  class="mat-icon" style="cursor: pointer;" (click)="closePopUp()" >close</mat-icon>
    <p class="title-delete">Are you sure that you want to delete "{{ title }}" from scheduled competition?</p>
    <div class="button">
        <button id="no-button" (click)="closePopUp()">No</button>
        <button id="yes-button" (click)="deleteCompetition()">Yes</button>
    </div>
</div>